export enum StepStatus {
    Pending = 'pending',
    Approved = 'approved',
    Denied = 'denied',
}
